module.exports = __webpack_public_path__ + "static/img/software-img.97c18ea.jpg";


//////////////////
// WEBPACK FOOTER
// ./static/img/software-img.jpg
// module id = 1733
// module chunks = 2